import { defineStore } from 'pinia';
import axios from 'axios';

export const contactSubTypes = defineStore('contact_sub_types', {
  state: () => ({ // data
    // eslint-disable-next-line fp/no-nil
    adminListPromise: null,
    // eslint-disable-next-line fp/no-nil
    listPromise: null,
    // eslint-disable-next-line fp/no-nil
    listPromiseShort: null,
    hashSettings: {},
  }),
  getters: { // computed
    adminListNoBasic () {
      return this.adminList().then(arr => arr.filter(el => !el.standard));
    },
    listNoBasic () {
      return this.listShort().then(arr => arr.filter(el => !el.standard));
    },
  },
  actions: { // methods
    adminList () {
      if (this.adminListPromise) return this.adminListPromise;
      this.adminListPromise = axios.get('/agency_admin/contact_sub_types')
          .then(r => r.data);
          // .then(r => this.list = r.data);
      return this.adminListPromise;
    },
    list () {
      if (this.listPromise) return this.listPromise;
      this.listPromise = axios.get('/contact_sub_types')
          .then(r => r.data);
      return this.listPromise;
    },
    listShort () {
      if (this.listPromiseShort) return this.listPromiseShort;
      this.listPromiseShort = axios.get('/contact_sub_types', { params: { short: true } })
          .then(r => r.data);
      return this.listPromiseShort;
    },
    allSettings (params = {}) {
      const uid = JSON.stringify(params);
      if (this.hashSettings[uid]) return this.hashSettings[uid];
      this.hashSettings[uid] = axios.get('/contact_sub_types/settings', { params })
          .then(r => r.data || {}).catch(e => {
            console.error(e);
            return {};
          });
      return this.hashSettings[uid];
    },
    settings (uid) {
      if (this.hashSettings[uid]) return this.hashSettings[uid];
      this.hashSettings[uid] = axios.get(`/contact_sub_types/${uid}/settings`)
          .then(r => r.data || {});
      return this.hashSettings[uid];
    },

    loadSettingsToOptions (toForm) {
      return this.settings(toForm.uid).then( data => {
        // eslint-disable-next-line fp/no-mutation
        toForm.options = { ...toForm.options, ...data };
        return toForm;
      });
    },
  },
});